Monitoring.Views ||= {}

class Monitoring.Views.TaggingRulesView extends Backbone.View
  template: JST["backbone/templates/monitoring/tagging_rules/tagging_rules"]

  events :
    'click #new-tagging-rule': 'onClickNewTaggingRule'

  initialize: (@options = {}) ->
    @taggingRules    = @options.tagging_rules
    @availableTopics = @options.available_topics
    @availableTags   = @options.available_tags
    @availableSentiments = [
      { value: 'nil', description: 'no sentiment' },
      { value: '-20', description: 'negative' },
      { value: '0',   description: 'neutral' },
      { value: '20',  description: 'positive' },
    ]

  render: =>
    @listView.remove() if @listView
    @editView.remove() if @editView
    @$el.html(@template(@))
    @renderList()
    @

  renderList: =>
    @listView.remove() if @listView
    @listView = new Monitoring.Views.TaggingRulesListView({
      taggingRules: @taggingRules
      availableTopics: @availableTopics
      availableTags: @availableTags
      availableSentiments: @availableSentiments
    })
    @$el.find('.list-view-container').append(@listView.render().el)
    @listenTo(@listView, 'edit', @renderEdit)

  onClickNewTaggingRule: ->
    @renderEdit()

  renderEdit: (tagging_rule = new Monitoring.Models.TaggingRule) ->
    @editView.remove() if @editView
    @editView = new Monitoring.Views.TaggingRulesEditView({
      taggingRule: tagging_rule
      availableTopics: @availableTopics
      availableTags: @availableTags
      availableSentiments: @availableSentiments
    })
    @$el.find('.edit-view-container').html(@editView.render().el)
    @listenTo(@editView, 'cancel', @render)
    @listenTo(@editView, 'afterSave', @afterSave)

  afterSave: (newTaggingRule) ->
    @taggingRules.push(newTaggingRule)
    @render()
